import type { FallbackProps } from "react-error-boundary";
import { Button } from "./ui/button/button";
import { TriangleAlert } from "lucide-react";
import { static_errors } from "@/axios/constants";
import Typography from "./ui/typography";

export default function ErrorFallback({ resetErrorBoundary }: FallbackProps) {
	const handleGoHome = () => {
		resetErrorBoundary();
		window.location.reload();
	};

	return (
		<div className="flex min-h-screen items-center justify-center bg-background px-4">
			<div className="w-full max-w-md text-center">
				<div className="mb-6">
					<TriangleAlert className="mx-auto h-16 w-16 text-destructive" />
				</div>

				<Typography variant={"h3"}>Something went wrong</Typography>

				<Typography variant={"p"} className="mb-8 mt-3 text-md">
					{static_errors.unexpected_contact_support}
				</Typography>

				<div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
					<Button onClick={handleGoHome}>Try Again</Button>
				</div>
			</div>
		</div>
	);
}
